module.exports = {
    API_URL: process.env.API_URL,
  };